import React, { useMemo } from 'react';
import { Form, LoadingIndicator, OccupyFreeSpace, PseudoLink2, SearchField, useDialogState } from '../../../toolympus/components/primitives';
import { MaybeFieldDefinition, TableForFields } from '../../../toolympus/components/schemed';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ActionTriggerEditButton } from '../../../toolympus/components/Actions';
import { AttendeeProfileConfigurationDialog } from './AttendeeProfileConfigurationDialog';
import { useAttendeesList } from './useAttendeesList';
import { AttendeeReviewDialog } from './AttendeeReviewDialog';
import { GetAppOutlined } from '@mui/icons-material';

interface Props {
  
}

export const AttendeesList = (props: Props) => {
  const data = useAttendeesList();
  const configDialog = useDialogState();


  const [fields] = useMemo(() => {
    const fields: MaybeFieldDefinition[] = [
      ["email"],
      ["display_name"],
      ...data.config.data.fields.map(f => [f._id] as MaybeFieldDefinition),
      ["created_at", { utcToLocal: true }],
    ];

    return [fields as MaybeFieldDefinition[]];
  }, [data.config.data]);

  // useOpenByIdFromUrl<ApplicationRecord>("id", "_id", data.data, x => data.review.startEditing(x), data.review.item?._id);
  
  return (<>
    <Form
      title="Attendees"
      fitFullHeight
      headerItems={<>
        <Typography variant="caption" color="textSecondary" style={{ alignSelf: "flex-end" }}>
          <FormattedMessage id="forms.page.submissions_total" values={{ total: data.count.data.total_records }} />
        </Typography>
        
        <OccupyFreeSpace />

        <Button
          size="small"
          onClick={() => data.exportAllRecordsAction.run()}
          startIcon={data.exportAllRecordsAction.isRunning ? <LoadingIndicator sizeVariant="s" /> : <GetAppOutlined />}>
          export all
        </Button>

        <Button
          size="small"
          onClick={() => data.exportAllWithRegRecordsAction.run()}
          startIcon={data.exportAllWithRegRecordsAction.isRunning ? <LoadingIndicator sizeVariant="s" /> : <GetAppOutlined />}>
          export with 1+ reg
        </Button>

        <SearchField
          filter={data.filter.filter}
          setFilter={data.filter.setFilter}
          noButton
          />
        

        
        <ActionTriggerEditButton
          apiPath="/api/actions/trigger"
          triggers={[
            "riac.attendees.attendees-entities/registered",
            "riac.attendees.attendees-entities/profile-filled",
            "riac.attendees.attendees-entities/password-reset",
          ]}
          />
        <Button size="small" color="primary" onClick={() => configDialog.open()}>configuration</Button>
      </>}>
      
      <TableForFields
        data={data.data}
        schema={data.schema}
        fields={fields}
        sorting={data.sorting}
        fieldElement={f => {
          
          switch(f) {
            case "email":
              return (r,s,orig) => <PseudoLink2 border onClick={() => data.review.startEditing(r)}>{orig}</PseudoLink2>
          }
        }}
        tailAnchor={data.limitTrigger.pagingAnchor}
        fieldLinkNewTab
        />
    </Form>

    <AttendeeProfileConfigurationDialog
      data={data.config}
      title="Configuration"
      {...configDialog}
      />

    <AttendeeReviewDialog
      data={data.editRecord}
      schema={data.schema}
      infoSchema={data.schema}
      infoFields={data.config.data.fields.map(f => [f._id])}
      />

    {/* <ApplicationReviewDialog
      data={data.review}
      schema={data.schema}
      profileConfiguration={data.config.data}
      remove={data.remove.run}
      editorBoard={editorBoard}
      updateRating={data.updateRating}
      /> */}

  </>);
}